import { UntypedFormControl } from '@angular/forms';

export function dateBeforeOtherCustomErrorValidator(otherControlName: string, customParam?: string) {
  let thisControl: UntypedFormControl;
  let otherControl: UntypedFormControl;

  return function validateDates(control: UntypedFormControl) {
    if (!control.parent) {
      return null;
    }

    if (!thisControl) {
      thisControl = control;
      otherControl = control.parent.get(otherControlName) as UntypedFormControl;
      if (!otherControl) {
        throw new Error('dateBeforeOtherCustomErrorValidator(): other control is not found in parent group');
      }
    }

    if (!otherControl) {
      return null;
    }

    const otherBeforeThis = new Date(otherControl.value)?.getTime() < new Date(thisControl.value)?.getTime();

    if (otherControl.value && thisControl.value && otherBeforeThis) {
      const param = customParam ? customParam : 'datesRange';
      return {
        [param]: true,
      };
    }

    return null;
  };
}
